import styled from '@emotion/styled';

export const ButtonDiv = styled('div')`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
  margin-right: 17px;
  margin-top: 1rem;
`;

export const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: '1px'
});

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
`;
